import { useApp } from "../../context/AppContext";

export function useBtpCapabilities() {
  const { bootstrap } = useApp();
  const membership = bootstrap?.membership;
  const role = membership?.role || "";
  const granted = new Set(membership?.permissions || []);
  const operationRoles = ["OWNER", "ADMIN", "MANAGER", "PROJECT_MANAGER"];
  const allow = (roles: string[], permission: string) =>
    Boolean(membership && (roles.includes(role) || granted.has(permission)));
  const legacy = {
    manage: allow(operationRoles, "btp.manage"),
    finance: allow([...operationRoles, "ACCOUNTANT"], "btp.manage_situations"),
    quotes: allow(["OWNER", "ADMIN"], "commercial.manage_quotes"),
    approve_quotes: allow(["OWNER", "ADMIN"], "commercial.approve_quotes"),
    approve: allow(["OWNER", "ADMIN"], "btp.approve_situations"),
    pay: allow(["OWNER", "ADMIN", "ACCOUNTANT"], "btp.pay_situations"),
  };
  const fromServer = membership?.btp;
  return {
    ...legacy,
    reports: legacy.manage, consumption: legacy.manage, dqe: legacy.manage,
    quality: legacy.manage, measure: legacy.finance, subcontract: legacy.manage, financial_read: true,
    costs: true, profile: fromServer?.profile || "", label: fromServer?.label || "",
    ...(fromServer ? Object.fromEntries(["quality", "quotes", "approve_quotes", "manage", "finance", "approve", "pay", "reports", "consumption", "dqe", "measure", "subcontract", "financial_read", "costs"].map(key => [key, fromServer.capabilities.includes(key)])) : {}),
  };
}
